module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text_m.41f84a26d1378743f3af8a4fd8671c0e.png";